import React from 'react'
import Form from './ResetForm'

const ResetForm = props => <Form {...props} />

export default ResetForm



// WEBPACK FOOTER //
// src/components/ResetForm/index.js